import React, { useState, useEffect } from "react";
import toastr from "toastr";
import { authFetch } from "../utils/authFetch";
import { Link } from "react-router-dom";
import { hasPerm } from "../utils/permission";

/* ---------------- helper ---------------- */
const blank = {
  name:"", email:"", mobile:"",
  address:"", state:"", city:"", pincode:"",
  pancard:"", aadharcard:"",
  scheme_id:"", role:"", status:true, 
  payin_api:"",payout_api:"",holding_payin_wallet:0,holding_payout_wallet:0,resellers:"",
};

const toast = (m,t="success")=>{
  toastr.options = { closeButton:true, progressBar:true, timeOut:3000 };
  toastr[t](m);
};
const boolToString = b => (b ? "active" : "inactive");
const stringToBool = s =>
  s === true || s === 1 || s === "true" || s === "active";

export default function Member() {

  const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
  const roleId = currentUser.role_id;
  const roleslug = currentUser.role_slug;
  // const isReseller = roleslug === "reseller";
  const RESELLER_ROLE_ID = "69366c4ce57577245472c779";
  const isReseller = roleslug === "reseller" && roleId === RESELLER_ROLE_ID;

  /* --------------- state --------------- */
  const [form,    setForm]    = useState(blank);
  const [rows,    setRows]    = useState([]);
  const [roles,   setRoles]   = useState([]);
  const [schemes, setSchemes] = useState([]);
  const [editId,  setEditId]  = useState(null);
  const [profile, setProfile] = useState(false);     // profile-update flag
  const [load,    setLoad]    = useState(false);

  const [payinApis,  setPayinApis]  = useState([]);
  const [payoutApis, setPayoutApis] = useState([]);

  const [resellers, setResellers] = useState([]);

  const [transferType, setTransferType] = useState("self");

  const loadResellers = async () => {
    const r = await authFetch("/api/v1/reseller/activelist");
    const d = await r.json();
    setResellers(Array.isArray(d) ? d : []);
  };
  
  const loadPayinApis = async () => {
    const r = await authFetch("/api/v1/api/getpayinlist");
    const d = await r.json();
    setPayinApis(Array.isArray(d) ? d : []);
  };

  const loadPayoutApis = async () => {
    const r = await authFetch("/api/v1/api/getpayoutlist");
    const d = await r.json();
    setPayoutApis(Array.isArray(d) ? d : []);
  };

  /* --------------- modal helper --------------- */
  const showModal = () => {
    const el = document.getElementById("memberModal");
    new window.bootstrap.Modal(el).show();
  };

  
  /* --------------- fetchers --------------- */
  const loadMembers = async ()=>{
    const r = await authFetch("/api/v1/member/userlist");
    const d = await r.json();
    // setRows((Array.isArray(d)?d:[]));
    // 1️⃣  हर रिकॉर्ड को normalize करो
    const normalized = (Array.isArray(d) ? d : []).map(m => ({
      ...m,
      status: stringToBool(m.status),
      payinstatus: stringToBool(m.payinstatus),
      payoutstatus: stringToBool(m.payoutstatus),
      // status:
      //   m.status === true ||
      //   m.status === 1 ||
      //   m.status === "true" ||
      //   m.status === "active"
    }));

    setRows(normalized);
  };
  const loadRoles = async ()=>{
    const r = await authFetch("/api/v1/role/list");
    setRoles(await r.json());
  };
  const loadSchemes = async ()=>{
    const r = await authFetch("/api/v1/scheme/list?status=active");
    setSchemes(await r.json());
  };
  useEffect(()=>{ loadMembers(); loadRoles(); loadSchemes(); loadPayinApis(); loadPayoutApis(); loadResellers(); },[]);

  /* --------------- handlers --------------- */
  const reset = ()=>{ setForm(blank); setEditId(null); setProfile(false); };

  const change = e=>{
    const {name,value,type,checked}=e.target;
    setForm({...form,[name]:type==="checkbox"?checked:value});
  };

  const editRow = (rec, isProfile=false)=>{
    setProfile(isProfile);
    setEditId(rec.id);                        
    setForm({
      name:rec.name||"",   email:rec.email||"",   mobile:rec.mobile||"",
      address:rec.address||"", state:rec.state||"", city:rec.city||"",
      pincode:rec.pincode||"", pancard:rec.pancard||"", aadharcard:rec.aadharcard||"",
      scheme_id:rec.scheme_id||"",
      // role:rec.role_id??rec.role??"", 
      role: rec.role_id || "", 
      status: stringToBool(rec.status),
      payout_api:rec.payout_api||"",payin_api:rec.payin_api||"",resellers:rec.resellers||"",
    });
    showModal();
  };

  const save = async ()=>{
    if(!form.name||!form.mobile||!form.role){
      toast("Name, Mobile & Role are required","error"); return;
    }
    setLoad(true);

    let url    = "/api/v1/member/create";
    let method = "POST";
    let body   = {...form,role_id: form.role,};

    if (editId && profile){
      url    = "/api/v1/member/profileupdate";
      method = "POST";
      body   = {...form, 
        id:editId, 
        actiontype:"profile",
        role_id: form.role,
      };
      delete body.role;
    } else if (editId){
      url    = "/api/v1/member/update";
      method = "PUT";
      body   = {...form, 
        id:editId,
        status: boolToString(form.status),
        role_id: form.role,
      };
      delete body.role;
    }

    try{
      const r = await authFetch(url,{
        method,
        headers:{ "Content-Type":"application/json" },
        body: JSON.stringify(body),
      });
      const d = await r.json();
      if(!r.ok) throw new Error(d.detail||"Failed");

      toast(editId?"Member updated":"Member created", editId?"info":"success");
      reset(); loadMembers();
      document.querySelector("#memberModal .btn-close")?.click();
    }catch(e){ toast(e.message,"error"); }
    finally{ setLoad(false); }
  };
  
  const toggleStatus = async (id, currentStatus) => {
  const nextStatusBool   = !currentStatus;                // flip locally
  const nextStatusString = nextStatusBool ? "active" : "inactive";

  
    setRows(prev =>
      prev.map(r => (r.id === id ? { ...r, status: nextStatusBool } : r)),
    );

    try {
      
      await authFetch("/api/v1/member/update", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, status: nextStatusString }),
      });
    } catch (err) {
      
      setRows(prev =>
        prev.map(r => (r.id === id ? { ...r, status: currentStatus } : r)),
      );
      toast("Status update failed", "error");
    }
  };

  useEffect(() => {
  if (rows.length === 0) return;

  const $ = window.$;
  const interval = setInterval(() => {
    const table = $("#example2");
    if (!table.length || !$.fn.DataTable) return;

    try {
      if ($.fn.DataTable.isDataTable(table)) {
        table.DataTable().destroy();
      }

      const dt = table.DataTable({
        lengthChange: false,
        pageLength: 10,
        // buttons: ["copy", "excel", "pdf", "print", "colvis"],
        order: [[0, "desc"]], // disable initial ordering
      });

      dt.buttons().container().appendTo("#example2_wrapper .col-md-6:eq(0)");
      clearInterval(interval);
    } catch (err) {
      console.error("DataTable init error:", err);
    }
  }, 100);

  return () => clearInterval(interval);
}, [rows]);


  /* --------------- JSX --------------- */
  // const [selectedUser, setSelectedUser] = useState(null);
  // const openTransferModal = (user) => {
  //   setSelectedUser(user);
  //   const el = document.getElementById("transferpayinAmtModal");
  //   new window.bootstrap.Modal(el).show();
  // };

  // transfer modal states
  const [selectedUser, setSelectedUser] = useState(null);
  const [isAuto, setIsAuto] = useState(false);
  const [amount, setAmount] = useState("");
  const [remark, setRemark] = useState("");

  const [releaseHoldingForm, setReleaseHoldingForm] = useState({
    walletType: "",
    amount: "",
    remark: "",
  });

  const [selectedReleaseUser, setSelectedReleaseUser] = useState(null);

  const openReleaseHoldingModal = (user) => {
    setSelectedReleaseUser(user);
    setReleaseHoldingForm({
      walletType: "",
      amount: "",
      remark: "",
    });

    const el = document.getElementById("releaseHoldingModal");
    new window.bootstrap.Modal(el).show();
  };

  const handleReleaseHoldingChange = (e) => {
    const { name, value } = e.target;

    setReleaseHoldingForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // open modal
  const openTransferModal = (user) => {
    setSelectedUser(user);
    setIsAuto(false);   // by default manual
    setAmount("");
    setRemark("");
    setTransferType("self");
    const el = document.getElementById("transferpayinAmtModal");
    new window.bootstrap.Modal(el).show();
  };

  // API call
  // const handleTransfer = async () => {
  //   if (!selectedUser) return;

  //   try {
  //     const r = await authFetch(`/api/v1/member/wallettransfer/${selectedUser.id}`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({
  //         mode: isAuto ? "automatic" : "manual",
  //         amount: isAuto ? null : Number(amount),
  //         remark: isAuto ? null : remark,
  //       }),
  //     });

  //     const d = await r.json();
  //     if (!r.ok) throw new Error(d.detail || d.status || "Transfer failed");

  //     toastr.success(d.status || "Transfer successful");
  //     // toastr.success(d.message || "Transfer successful");

  //     // modal close
  //     document.querySelector("#transferpayinAmtModal .btn-close")?.click();

  //     // refresh members list
  //     loadMembers();
  //   } catch (err) {
  //     toastr.error(err.message);
  //   }
  // };

  const handleTransfer = async () => {
    if (!selectedUser) return;

    try {
      const endpoint =
        transferType === "self"
          ? `/api/v1/member/wallettransfer/${selectedUser.id}`
          : `/api/v1/member/wallettransferveer/${selectedUser.id}`;

      const r = await authFetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          mode: isAuto ? "automatic" : "manual",
          amount: isAuto ? null : Number(amount),
          remark: isAuto ? null : remark,
        }),
      });

      const d = await r.json();

      if (!r.ok) {
        throw new Error(
          d.detail || d.message || d.status || "Transfer failed"
        );
      }

      toastr.success(d.message || d.status || "Transfer successful");

      // Close modal
      document.querySelector("#transferpayinAmtModal .btn-close")?.click();

      // Refresh members list
      loadMembers();

    } catch (err) {
      toastr.error(err.message || "Transfer failed");
    }
  };

  
  const [holdingForm, setHoldingForm] = useState({
    walletType: "",
    amount: "",
    remark: "",
  });
  const [selectedHoldingUser, setSelectedHoldingUser] = useState(null);

  // open modal
  const openHoldingModal = (user) => {
    setSelectedHoldingUser(user);
    setHoldingForm({ walletType: "", amount: "", remark: "" });
    const el = document.getElementById("holdingModal");
    new window.bootstrap.Modal(el).show();
  };


  // handle input change
  const handleHoldingChange = (e) => {
    const { name, value } = e.target;
    setHoldingForm((prev) => ({ ...prev, [name]: value }));
  };

  // submit handler
  const handleHoldingSubmit = async () => {
    if (!selectedHoldingUser || !holdingForm.walletType || !holdingForm.amount) {
      toastr.error("Please fill all required fields");
      return;
    }

    try {
      const r = await authFetch(
        `/api/v1/member/hold_amount/${selectedHoldingUser.id}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            wallet_type: holdingForm.walletType, // "payin" या "main"
            amount: Number(holdingForm.amount),
            remark: holdingForm.remark,
          }),
        }
      );

      const d = await r.json();
      if (!r.ok) throw new Error(d.detail || d.message || "Failed");

      toastr.success(d.message || "Holding wallet updated");
      document.querySelector("#holdingModal .btn-close")?.click();
      loadMembers();
    } catch (err) {
      toastr.error(err.message);
    }
  };

  const togglePayinStatus = async (id, currentStatus) => {
  const nextStatusBool   = !currentStatus;
  const nextStatusString = nextStatusBool ? "active" : "inactive";

  // UI update
  setRows(prev =>
    prev.map(r => (r.id === id ? { ...r, payinstatus: nextStatusBool } : r)),
  );

  try {
    await authFetch("/api/v1/member/update", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id, payinstatus: nextStatusString }),
    });
  } catch (err) {
    // rollback UI on error
    setRows(prev =>
      prev.map(r => (r.id === id ? { ...r, payinstatus: currentStatus } : r)),
    );
    toastr.error("Payin status update failed");
  }
};


const togglePayoutStatus = async (id, currentStatus) => {
  const nextStatusBool   = !currentStatus;
  const nextStatusString = nextStatusBool ? "active" : "inactive";

  // UI update
  setRows(prev =>
    prev.map(r => (r.id === id ? { ...r, payoutstatus: nextStatusBool } : r)),
  );

  try {
    await authFetch("/api/v1/member/update", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id, payoutstatus: nextStatusString }),
    });
  } catch (err) {
    // rollback UI
    setRows(prev =>
      prev.map(r => (r.id === id ? { ...r, payoutstatus: currentStatus } : r)),
    );
    toastr.error("Payout status update failed");
  }
};

const [rowsWithRole, setRowsWithRole] = useState([]);

useEffect(() => {
  const mapped = rows.map(r => {
    const roleObj = roles.find(role => String(role.id) === String(r.role_id));
    return { ...r, roleName: roleObj ? roleObj.name : "-" };
  });
  setRowsWithRole(mapped);
}, [rows, roles]);


const openDeductModal = (user) => {
  setSelectedDeductUser(user);
  setDeductForm({ walletType: "", amount: "", remark: "" });
  const el = document.getElementById("deductModal");
  new window.bootstrap.Modal(el).show();
};

const [selectedDeductUser, setSelectedDeductUser] = useState(null);

const [deductForm, setDeductForm] = useState({
  walletType: "",
  amount: "",
  remark: "",
});

const handleDeductSubmit = async () => {
  if (!selectedDeductUser || !deductForm.walletType || !deductForm.amount) {
    toastr.error("Please fill all required fields");
    return;
  }

  try {
    const r = await authFetch(
      `/api/v1/member/deduct_amount/${selectedDeductUser.id}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          wallet_type: deductForm.walletType,
          amount: Number(deductForm.amount),
          remark: deductForm.remark,
        }),
      }
    );

    const d = await r.json();
    if (!r.ok) throw new Error(d.detail || d.message || "Failed");

    toastr.success(d.message || "Amount deducted successfully");

    document.querySelector("#deductModal .btn-close")?.click();
    loadMembers();
  } catch (err) {
    toastr.error(err.message);
  }
};

const handleReleaseHoldingSubmit = async () => {

  console.log("selectedReleaseUser", selectedReleaseUser);
  console.log("releaseHoldingForm", releaseHoldingForm);
  if (
    !selectedReleaseUser ||
    !releaseHoldingForm.walletType ||
    !releaseHoldingForm.amount
  ) {
    toastr.error("Please fill all required fields");
    return;
  }

  try {
    const r = await authFetch(
      `/api/v1/member/release_hold_amount/${selectedReleaseUser.id}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          wallet_type: releaseHoldingForm.walletType,
          amount: Number(releaseHoldingForm.amount),
          remark: releaseHoldingForm.remark,
        }),
      }
    );

    const d = await r.json();

    if (!r.ok) {
      throw new Error(d.detail || d.message || "Failed");
    }

    toastr.success(
      d.message || "Holding amount released successfully"
    );

    document.querySelector(
      "#releaseHoldingModal .btn-close"
    )?.click();

    loadMembers();
  } catch (err) {
    toastr.error(err.message);
  }
};

const handleDeductChange = (e) => {
  const { name, value } = e.target;
  setDeductForm((prev) => ({ ...prev, [name]: value }));
};

  return (
    <>
    <style>
      {`
      .table-responsive {
          white-space: normal;
          
      }
       //   hr {
        //     margin: .5rem 0rem;
        //     color: inherit;
        //     background-color: currentColor;
        //     border: 0;
        //     opacity: 8.25;
        // } 
    `}
    </style> 
    <div className="page-wrapper">
      <div className="page-content-wrapper"><div className="page-content">
        <div className="card"><div className="card-body">

          {/* header */}
          {hasPerm("members_add") && (
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="mb-0">Member Manager</h4>
            <button className="btn btn-primary" onClick={()=>{ reset(); showModal(); }}>
              Add
            </button>
          </div>
          )}
          {/* modal */}
          <div className="modal fade" id="memberModal" tabIndex="-1" aria-hidden="true">
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    {editId ? (profile ? "Profile Update" : "Edit Member") : "Add Member"}
                  </h5>
                  <button className="btn-close" data-bs-dismiss="modal" onClick={reset}/>
                </div>
                <div className="modal-body row">
                  {["name","email","mobile","address","state","city","pincode","pancard","aadharcard"].map(f=>(
                    <div className="col-md-6 mb-2" key={f}>
                      <label className="form-label text-capitalize">{f}</label>
                      <input className="form-control" name={f} value={form[f]} onChange={change}/>
                    </div>
                  ))}

                  <div className="col-md-6 mb-2">
                    <label className="form-label">Scheme</label>
                    <select className="form-control" name="scheme_id" value={form.scheme_id} onChange={change}>
                      <option value="" selected disabled>-- Select Scheme --</option>
                      {schemes.map(s=>(
                        <option key={s.id||s._id} value={s.id||s._id}>{s.name}</option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6 mb-2">
                    <label className="form-label">Reseller</label>
                    <select
                      className="form-control form-select"
                      name="resellers"
                      value={form.resellers}
                      onChange={change}
                    >
                      <option value="" selected disabled>-- Select Reseller --</option>
                      {resellers.map(re => (
                        <option key={re.id || re._id} value={re.id || re._id}>
                          {re.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6 mb-2">
                    <label className="form-label">Role</label>
                    <select className="form-control" name="role" value={form.role} onChange={change}>
                      <option value="" selected disabled>-- Select Role --</option>
                      {roles.map(r=>(
                        <option key={r.id||r._id} value={r.id||r._id}>{r.name??r.slug}</option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6 mb-2">
                    <label className="form-label">Payin Service</label>
                    <select
                      className="form-select"
                      name="payin_api"
                      value={form.payin_api || ""}
                      onChange={change}
                    >
                      <option value="" selected disabled>-- Select Payin API --</option>
                      {payinApis.map(api => (
                        <option key={api.code} value={api.code}>{api.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6 mb-2">
                    <label className="form-label">Payout Service</label>
                    <select
                      className="form-select"
                      name="payout_api"
                      value={form.payout_api || ""}
                      onChange={change}
                    >
                      <option value="" selected disabled>-- Select Payout API --</option>
                      {payoutApis.map(api => (
                        <option key={api.code} value={api.code}>{api.name}</option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6 mb-2">
                    <label className="form-check">
                      <input type="checkbox" className="form-check-input" name="status"
                            checked={form.status} onChange={change}/> Active
                    </label>
                  </div>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-secondary" data-bs-dismiss="modal" onClick={reset}>Close</button>
                  <button className="btn btn-primary" onClick={save} disabled={load}>
                    {load ? "Saving…" : editId ? "Update" : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* table */}
          <hr/>
          <div className="table-responsive">
            <table id="example2" className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Merchant Code</th>
                  <th>Company Profile</th>
                  <th>Company Address</th>
                  <th>Wallet</th>
                  {/* <th>Status</th>
                  <th>Action</th> */}
                  {(hasPerm("member_user_status") || hasPerm("member_payin_status") || hasPerm("member_payout_status") ) && (
                  <th>Status</th>
                  )}
                  {(hasPerm("member_edit") || hasPerm("member_action")) && (
                  <th>Action</th>
                  )}
                  </tr>
              </thead>
              <tbody>
                {rowsWithRole.length===0 && (
                  <tr><td colSpan="6" className="text-center">No members found</td></tr>
                )}
                {/* {rows.map(r=>( */}
                {rowsWithRole.map((r, i) => (
                  
                  <tr key={r.id}>
                    <td>{i + 1}</td> 
                    {/* <td>{r.id}</td> */}
                    <td><span className="badge rounded-pill bg-dark">{r.merchantcode}</span><br/>
                        <b> Payin API:</b> {r.payin_api} , <br/> <b> Payout API:</b> {r.payout_api}</td>
                    <td style={{ fontSize: "14px" }}><b>Name :</b> {r.name} <br/> <b>Email :</b> {r.email} <br/>
                    <b> Mobile No.:</b> {r.mobile} <br/> <b> Role:</b> {r.roleName}
                        {r.resellers
                          ? (() => {
                              const reseller = resellers.find(
                                re => String(re.id || re._id) === String(r.resellers)
                              );

                              return reseller ? (
                                <>
                                <hr/>
                                  <b>Reseller Details:</b>{" "}<br/>
                                  {reseller.name} , {reseller.mobile} , {reseller.email}
                                </>
                              ) : "-";
                            })()
                          : "-"
                        }
                    </td>
                    <td style={{ fontSize: "14px", textWrapStyle: "balance" }}>{r.address}, {r.pincode}, {r.city} </td>
                    <td>
                      <b>Payin Wallet:</b> ₹: {(r.payinwallet ?? 0).toFixed(2)} <br/> 
                      <b>Holding Payin:</b> ₹: {(r.holding_payin_wallet ?? 0).toFixed(2)} <hr/>
                      <b>Payout Wallet:</b> ₹: {(r.mainwallet ?? 0).toFixed(2)} <br/>
                      <b>Holding Payout:</b> ₹: {(r.holding_payout_wallet ?? 0).toFixed(2)} <br/>
                      
                    </td>
                    {/* <td>{r.status ? "Active" : "Inactive"}</td> */}
                    {/* <td>
                      <div className="form-check form-switch">
                        <input className="form-check-input" type="checkbox" id="flexSwitchCheckChecked" checked=""/>
                      </div>
                    </td> */}
                    {(hasPerm("member_user_status") || hasPerm("member_payin_status") || hasPerm("member_payout_status") ) && (
                    <td style={{ fontSize: "12px" }}>
                      {hasPerm("member_user_status") && (
                        <>
                      <label className="form-label">User Status</label>
                      <div className="form-check form-switch">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`status-${r.id}`}
                          checked={!!r.status}
                          onChange={() => toggleStatus(r.id, !!r.status)}
                        />
                      </div>
                      <hr/>
                      </>
                      )}
                      {hasPerm("member_payin_status") && (
                        <>
                      <label className="form-label">Payin Status</label>
                      <div className="form-check form-switch">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`payinstatus-${r.id}`}
                          checked={!!r.payinstatus}
                          onChange={() => togglePayinStatus(r.id, !!r.payinstatus)}
                        />
                      </div>
                      <hr/>
                      </>
                      )}
                      {hasPerm("member_payout_status") && (
                        <>
                      <label className="form-label">Payout Status</label>
                      <div className="form-check form-switch">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`payoutstatus-${r.id}`}
                          checked={!!r.payoutstatus}
                          onChange={() => togglePayoutStatus(r.id, !!r.payoutstatus)}
                        />
                      </div>
                     </>
                      )}
                    </td>
                    )}
                    {(hasPerm("member_edit") || hasPerm("member_action")) && (
                    <td>
                      {hasPerm("member_edit") && (
                      <button className="btn btn-sm btn-info me-1" onClick={()=>editRow(r,false)}>
                        <span className="bx bx-edit-alt"/>
                      </button>
                      )}
                      {/* <button className="btn btn-sm btn-warning" onClick={()=>editRow(r,true)}>
                        <span className="bx bx-user"/>
                      </button> */}
                      {hasPerm("member_action") && (
                    <button type="button" className="btn btn-primary bg-split-primary dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown">	<span class="sr-only">FYA </span>
                    </button>
                    )}
                    <div className="dropdown-menu dropdown-menu-right dropdown-menu-lg-left">	
                      {hasPerm("api_user_profile_show") && (
                      <Link className="dropdown-item" to={`/view_profile/${r.id}`}>View Profile</Link>
                      )}
                      {hasPerm("set_permission_show") && (
                      <Link className="dropdown-item" to={`/set_permission/${r.id}`}>Set Permission</Link>
                      )}
                      {hasPerm("commission_show") && (
                      <Link className="dropdown-item" to={`/CommissionSlab/${r.scheme_id}`}>Commission </Link>
                      )}
                      {/* <Link className="dropdown-item" to="set_payin_api">Set Payin API</Link> */}
                      {hasPerm("transfer_payin_amt_show") && (
                      <button className="dropdown-item" onClick={() => openTransferModal(r)}>
                        Transfer Payin Amt
                      </button>
                      )}
                      {hasPerm("holding_amount_show") && (
                        <>
                      <button className="dropdown-item" onClick={() => openHoldingModal(r)}>
                        Holding Amount
                      </button>

                      <button
                        className="dropdown-item"
                        onClick={() => openReleaseHoldingModal(r)}
                      >
                        Release Holding Amount
                      </button>
                      </>
                      )}
                      {hasPerm("deduct_amount_show") && (
                      <button className="dropdown-item" onClick={() => openDeductModal(r)}>
                        deduct Amount
                      </button>
                      )}
                      {/* <Link className="dropdown-item" to="payout_statement">Payout Statement</Link> */}
                      {/* <div className="dropdown-divider"></div>	 */}
                      
                    </div>

                    </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

              {/* ---------------- Holding Amount Modal ---------------- */}
              <div
                className="modal fade"
                id="holdingModal"
                tabIndex="-1"
                aria-labelledby="holdingModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="holdingModalLabel">
                        Holding Wallet Adjustment
                      </h5>
                      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <div className="modal-body">
                      {selectedHoldingUser ? (
                        <>
                          <div className="border rounded p-3 bg-light mb-3">
                            <div className="mb-2">
                              <strong>ID:</strong> {selectedHoldingUser.id}
                            </div>
                            <div className="mb-2">
                              <strong>Name:</strong> {selectedHoldingUser.name || "N/A"}
                            </div>
                            <div className="mb-2">
                              <strong>Mobile:</strong> {selectedHoldingUser.mobile || "N/A"}
                            </div>
                            <div className="mb-0">
                              <strong>Email:</strong> {selectedHoldingUser.email || "N/A"}
                            </div>
                          </div>
                          {/* Wallet Balances */}
                          <div className="mb-3 border rounded p-3 bg-light">
                            <div className="d-flex justify-content-between">
                              <div><strong>Payin Wallet:</strong></div>
                              <div>₹ {selectedHoldingUser.payinwallet ?? 0}</div>
                            </div>
                            <div className="d-flex justify-content-between mt-2">
                              <div><strong>Main Wallet:</strong></div>
                              <div>₹ {selectedHoldingUser.mainwallet ?? 0}</div>
                            </div>

                            {selectedHoldingUser.holding_payin_wallet !== undefined && (
                              <div className="d-flex justify-content-between mt-2">
                                <div><strong>Holding Payin Wallet:</strong></div>
                                <div>₹ {selectedHoldingUser.holding_payin_wallet ?? 0}</div>
                              </div>
                            )}
                            {selectedHoldingUser.holding_payout_wallet !== undefined && (
                              <div className="d-flex justify-content-between mt-2">
                                <div><strong>Holding Payout Wallet:</strong></div>
                                <div>₹ {selectedHoldingUser.holding_payout_wallet ?? 0}</div>
                              </div>
                            )}
                          </div>

                          {/* Form Fields */}
                          <div className="mb-3">
                            <label className="form-label">Wallet Type</label>
                            <select
                              name="walletType"
                              className="form-select"
                              value={holdingForm.walletType}
                              onChange={handleHoldingChange}
                            >
                              <option value="">Select Wallet</option>
                              <option value="payin">Payin Wallet</option>
                              <option value="payout">Main Wallet</option>
                            </select>
                          </div>

                          <div className="mb-3">
                            <label className="form-label">Amount</label>
                            <input
                              type="number"
                              name="amount"
                              className="form-control"
                              value={holdingForm.amount}
                              onChange={handleHoldingChange}
                              placeholder="Enter amount"
                            />
                          </div>

                          <div className="mb-3">
                            <label className="form-label">Remark</label>
                            <textarea
                              name="remark"
                              className="form-control"
                              rows="2"
                              value={holdingForm.remark}
                              onChange={handleHoldingChange}
                              placeholder="Enter remark (optional)"
                            ></textarea>
                          </div>
                        </>
                      ) : (
                        <div className="text-center text-muted">Loading user data...</div>
                      )}
                    </div>

                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                        Close
                      </button>
                      <button type="button" className="btn btn-primary" onClick={handleHoldingSubmit}>
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* ---------------- Release Holding Amount Modal ---------------- */}
              <div
                className="modal fade"
                id="releaseHoldingModal"
                tabIndex="-1"
                aria-labelledby="releaseHoldingModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="releaseHoldingModalLabel">
                        Release Holding Amount
                      </h5>
                      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <div className="modal-body">
                      {selectedReleaseUser  ? (
                        <>
                          <div className="border rounded p-3 bg-light mb-3">
                            <div className="mb-2">
                              <strong>ID:</strong> {selectedReleaseUser .id}
                            </div>
                            <div className="mb-2">
                              <strong>Name:</strong> {selectedReleaseUser .name || "N/A"}
                            </div>
                            <div className="mb-2">
                              <strong>Mobile:</strong> {selectedReleaseUser .mobile || "N/A"}
                            </div>
                            <div className="mb-0">
                              <strong>Email:</strong> {selectedReleaseUser .email || "N/A"}
                            </div>
                          </div>
                          {/* Wallet Balances */}
                          <div className="mb-3 border rounded p-3 bg-light">
                            <div className="d-flex justify-content-between">
                              <div><strong>Payin Wallet:</strong></div>
                              <div>₹ {selectedReleaseUser .payinwallet ?? 0}</div>
                            </div>
                            <div className="d-flex justify-content-between mt-2">
                              <div><strong>Main Wallet:</strong></div>
                              <div>₹ {selectedReleaseUser .mainwallet ?? 0}</div>
                            </div>

                            {selectedReleaseUser.holding_payin_wallet !== undefined && (
                              <div className="d-flex justify-content-between mt-2">
                                <div><strong>Holding Payin Wallet:</strong></div>
                                <div>₹ {selectedReleaseUser.holding_payin_wallet ?? 0}</div>
                              </div>
                            )}
                            {selectedReleaseUser.holding_payout_wallet !== undefined && (
                              <div className="d-flex justify-content-between mt-2">
                                <div><strong>Holding Payout Wallet:</strong></div>
                                <div>₹ {selectedReleaseUser.holding_payout_wallet ?? 0}</div>
                              </div>
                            )}
                          </div>

                          {/* Form Fields */}
                          <div className="mb-3">
                            <label className="form-label">Wallet Type</label>
                            <select
                              name="walletType"
                              className="form-select"
                              value={releaseHoldingForm.walletType}
                              onChange={handleReleaseHoldingChange}
                            >
                              <option value="">Select Wallet</option>
                              <option value="payin">Payin Wallet</option>
                              <option value="payout">Main Wallet</option>
                            </select>
                          </div>

                          <div className="mb-3">
                            <label className="form-label">Amount</label>
                            <input
                              type="number"
                              name="amount"
                              className="form-control"
                              value={releaseHoldingForm.amount}
                              onChange={handleReleaseHoldingChange}
                            />
                          </div>

                          <div className="mb-3">
                            <label className="form-label">Remark</label>
                            <textarea
                              name="remark"
                              className="form-control"
                              value={releaseHoldingForm.remark}
                              onChange={handleReleaseHoldingChange}
                            />
                          </div>
                        </>
                      ) : (
                        <div className="text-center text-muted">Loading user data...</div>
                      )}
                    </div>

                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                        Close
                      </button>
                      <button type="button" className="btn btn-primary" onClick={handleReleaseHoldingSubmit}>
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              

              {/* ---------------- Deduct Amount Modal ---------------- */}
          <div
            className="modal fade"
            id="deductModal"
            tabIndex="-1"
            aria-labelledby="deductModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                
                <div className="modal-header">
                  <h5 className="modal-title" id="deductModalLabel">
                    Wallet Deduction
                  </h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                </div>

                <div className="modal-body">
                  {selectedDeductUser ? (
                    <>
                      {/* User Info */}
                      <div className="border rounded p-3 bg-light mb-3">
                        <div><strong>ID:</strong> {selectedDeductUser.id}</div>
                        <div><strong>Name:</strong> {selectedDeductUser.name || "N/A"}</div>
                        <div><strong>Mobile:</strong> {selectedDeductUser.mobile || "N/A"}</div>
                        <div><strong>Email:</strong> {selectedDeductUser.email || "N/A"}</div>
                      </div>

                      {/* Wallet Balances */}
                      <div className="mb-3 border rounded p-3 bg-light">
                        <div className="d-flex justify-content-between">
                          <div><strong>Payin Wallet:</strong></div>
                          <div>₹ {selectedDeductUser.payinwallet ?? 0}</div>
                        </div>

                        <div className="d-flex justify-content-between mt-2">
                          <div><strong>Main Wallet:</strong></div>
                          <div>₹ {selectedDeductUser.mainwallet ?? 0}</div>
                        </div>
                      </div>

                      {/* Form */}
                      <div className="mb-3">
                        <label className="form-label">Wallet Type</label>
                        <select
                          name="walletType"
                          className="form-select"
                          value={deductForm.walletType}
                          onChange={handleDeductChange}
                        >
                          <option value="">Select Wallet</option>
                          <option value="payin">Payin Wallet</option>
                          <option value="payout">Main Wallet</option>
                        </select>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Amount</label>
                        <input
                          type="number"
                          name="amount"
                          className="form-control"
                          value={deductForm.amount}
                          onChange={handleDeductChange}
                          placeholder="Enter amount"
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Remark</label>
                        <textarea
                          name="remark"
                          className="form-control"
                          rows="2"
                          value={deductForm.remark}
                          onChange={handleDeductChange}
                          placeholder="Enter remark (optional)"
                        ></textarea>
                      </div>
                    </>
                  ) : (
                    <div className="text-center text-muted">Loading user data...</div>
                  )}
                </div>

                <div className="modal-footer">
                  <button className="btn btn-secondary" data-bs-dismiss="modal">
                    Close
                  </button>
                  <button className="btn btn-danger" onClick={handleDeductSubmit}>
                    Deduct Amount
                  </button>
                </div>

              </div>
            </div>
          </div>




       
											{/* <div class="modal fade" id="transferpayinAmtModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
												<div class="modal-dialog">
													<div class="modal-content">
														<div class="modal-header">
															<h5 class="modal-title" id="exampleModalLabel">Transfer Payin Amount</h5>
															<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
														</div>
														<div class="modal-body">

                            </div>
														<div class="modal-footer">
															<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
															<button type="button" class="btn btn-primary">Save changes</button>
														</div>
													</div>
												</div>
											</div> */}

        </div></div>
      </div></div>
    </div>


    {/* Transfer Payin Modal */}
    <div className="modal fade" id="transferpayinAmtModal" tabIndex="-1" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Transfer Payin Amount</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div className="modal-body">
            {selectedUser ? (
              <>
                {/* Toggle Manual / Automatic */}
                <div className="form-check form-switch mb-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="transferModeSwitch"
                    checked={isAuto}
                    onChange={(e) => setIsAuto(e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="transferModeSwitch">
                    {isAuto ? "Automatic Transfer (₹5 lakh fixed)" : "Manual Transfer"}
                  </label>
                </div>

                {/* User Info */}
                <p><strong>User ID:</strong> {selectedUser.id}</p>
                <p><strong>User Name:</strong> {selectedUser.name}</p>
                <p><strong>Payin Wallet:</strong> ₹{selectedUser.payinwallet ?? 0}</p>
                <p><strong>Main Wallet:</strong> ₹{selectedUser.mainwallet ?? 0}</p>

                {/* Manual Fields (only if not auto) */}
                {!isAuto && (
                  <>
                    <div className="mb-3">
                      <label className="form-label">Transfer To</label>
                      <select
                        className="form-select"
                        value={transferType}
                        onChange={(e) => setTransferType(e.target.value)}
                      >
                        <option value="self">Self</option>
                        <option value="ruaanya">Ruaanya Fintech</option>
                      </select>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Enter Amount to Transfer</label>
                      <input
                        type="number"
                        className="form-control"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        placeholder="Enter amount"
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Enter Remark</label>
                      <input
                        type="text"
                        className="form-control"
                        value={remark}
                        onChange={(e) => setRemark(e.target.value)}
                        placeholder="Enter remark"
                      />
                    </div>
                  </>
                )}
              </>
            ) : (
              <p>No user selected</p>
            )}
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleTransfer}
              disabled={!isAuto && !amount}  // manual ke liye amount required
            >
              Transfer
            </button>
          </div>
        </div>
      </div>
    </div>

    </>
  );
}
